import React, { useMemo } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { buildPerformanceChartData } from './performanceData';

const PerformanceGraphs = ({ cycles, currentCycle }) => {
  // Memoize the data transformation to prevent unnecessary recalculations
  const chartData = useMemo(
    () => buildPerformanceChartData(cycles, currentCycle),
    [cycles, currentCycle]
  );

  if (chartData.length < 1) {
    return null;
  }

  return (
    <div className="min-w-0 text-left">
      <h2 className="mb-5 text-base font-semibold text-slate-800">Performance trends</h2>
      <div className="grid min-w-0 gap-6 md:grid-cols-2">
        {/* Accuracy Graph */}
        <div className="min-w-0">
          <h3 className="mb-3 text-sm font-medium text-slate-600">Accuracy per cycle</h3>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={chartData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="cycleNumber" />
              <YAxis domain={[0, 100]} />
              <Tooltip 
                formatter={(value) => [`${value}%`, 'Accuracy']}
                labelFormatter={(label) => `Cycle ${label}`}
              />
              <Line
                type="monotone"
                dataKey="accuracy"
                stroke="#8884d8"
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Time Graph */}
        <div className="min-w-0">
          <h3 className="mb-3 text-sm font-medium text-slate-600">Time per cycle (minutes)</h3>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={chartData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="cycleNumber" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`${value} min`, 'Time']}
                labelFormatter={(label) => `Cycle ${label}`}
              />
              <Line
                type="monotone"
                dataKey="timeSpent"
                stroke="#82ca9d"
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default PerformanceGraphs; 
